// extracted by mini-css-extract-plugin
export default {"wrapper":"TeaseVideo_wrapper__jpMNd","player":"TeaseVideo_player__QnKxA","wave":"TeaseVideo_wave__Xwg7c"};